import { Divider, ListItem } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PersonIcon from "@material-ui/icons/Person";
import MessageInfo from "components/system/message-info/MessageInfo";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAppContext } from "../../../context/AuthContext";
import Labels from "../../../lang/Labels_en";
import UserService, { UserServiceType } from "../../../service/user/UserService";
import useStyles from "./HeaderStyle";
export default function Header() {
  const { logout }: UserServiceType = UserService();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const { authData } = useAppContext();
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const userNameFirstname = authData?.user.firstName + " " + authData?.user.lastName;
  const history = useHistory();
  const renderMenu = (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      id="customized-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <ListItem
        button
        onClick={() => {
          handleClose();
          history.push("/profile");
        }}
      >
        <ListItemIcon>
          <PersonIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={Labels.PROFILE} />
      </ListItem>
      <Divider />
      <ListItem button onClick={logout}>
        <ListItemIcon>
          <ExitToAppIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={Labels.LOGOUT} />
      </ListItem>
    </Menu>
  );
  return (
    <div>
      <MessageInfo />
      <AppBar position="fixed" style={{ marginTop: "20px" }}>
        <Toolbar>
          <div className={classes.menuButton}>
            <Link to="/" className={classes.link}>
              <Typography className={classes.title} variant="h6" noWrap>
                {Labels.RHNILOGY_REVIEW_SYSTEM}
              </Typography>
            </Link>
          </div>
          <div className={classes.linkGroup}></div>
          <div className={classes.sectionDesktop}>
            <div className={classes.centeredContentContainer}>
              <Link to="/profile" className={classes.link}>
                <Typography className={classes.userLabel} noWrap>
                  {userNameFirstname}
                </Typography>
              </Link>
            </div>
            ​
            <IconButton color="inherit" onClick={handleClick}>
              <AccountCircleIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </div>
  );
}
